/* eslint-disable import/no-internal-modules */
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import queryString from 'query-string';
import { ENV } from '../../config';
import { getClientToken } from '../../libs/auth-context';

import { GetUserQueryKey } from './keys';

export function useLogoutMutation() {
  return useMutation<unknown, unknown, unknown, unknown>([GetUserQueryKey], async () => {
    const token = getClientToken();

    await axios.get<unknown, unknown>(
      `${ENV.API}/auth/logout/?${queryString.stringify({ token })}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    );
  });
}
